<template>
  <Head :title="`Editing ${order.name}`" />

  <div class="mx-auto max-w-2xl py-6">
    <Form
      :order="order"
      :members="membersList"
      submit-text="Update Order"
      :is-submitting="isSubmitting"
      :form-errors="formErrors"
      @on-submit="handleSubmit"
    />
  </div>
</template>

<script setup lang="ts">
import { Head, router } from "@inertiajs/vue3"
import { useToast } from "primevue/usetoast"
import { computed, reactive, ref } from "vue"

import { apolloClient } from "../../queries/client"
import UPDATE_ORDER from "../../queries/order/update.gql"
import Form from "./Form.vue"
import { CompanyWithMembers, OrderFormType, OrderType } from "./types"

const toast = useToast()

interface OrderWithCompanyMembers extends OrderType {
  company: CompanyWithMembers
}

const props = defineProps<{
  order: OrderWithCompanyMembers
}>()

const isSubmitting = ref(false)
const formErrors = reactive<Record<string, string>>({})

const membersList = computed(() => props.order.company.members)

const handleSubmit = async (formData: OrderFormType) => {
  console.log("order.gid:", props.order.gid)
  console.log("order.id:", props.order.id)
  isSubmitting.value = true
  Object.keys(formErrors).forEach((key) => delete formErrors[key])

  try {
    const result = await apolloClient.mutate({
      mutation: UPDATE_ORDER,
      variables: {
        orderId: props.order.gid,
        officerId: formData.officerId || null,
        externalFileNumber: formData.externalFileNumber || null,
        verificationEnabled: formData.verificationEnabled,
        documentEmailEnabled: formData.documentEmailEnabled,
      },
    })

    if (result?.data?.updateOrder?.errors?.length) {
      const errors = result.data.updateOrder.errors
      toast.add({
        severity: "error",
        summary: "Error",
        detail: errors.join(", "),
        life: 5000,
      })
      return
    }

    toast.add({
      severity: "success",
      summary: "Success",
      detail: "Order updated successfully",
      life: 4000,
    })

    router.visit(`/orders/${props.order.gid}`)
  } catch (error) {
    console.error("Mutation error:", error)
    toast.add({
      severity: "error",
      summary: "Error",
      detail: "Failed to update order",
      life: 5000,
    })
  } finally {
    isSubmitting.value = false
  }
}
</script>
